module.exports = __webpack_public_path__ + "static/media/fr.684cc20f.svg";